export default "__VITE_ASSET__BCCkLdgW__"